"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
var _HeaderNav = _interopRequireDefault(require("./HeaderNav"));
var _dateFns = require("date-fns");
var _AlertNotification = _interopRequireDefault(require("../../renderings/AlertNotification"));
var _sitecoreJssReact = require("@sitecore-jss/sitecore-jss-react");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var Header = props => {
  var _props$route$fields$N;
  if (!props.route.fields) return null;
  var appName = props.params.testApp == 'scTestGroove' ? 'scTestGroove' : props.params.appName;
  var startDate, expireDate;
  var alertData = null;
  var selectedSiteNav = props.route.fields.SiteNavName.value;
  var getURLQuery = new URLSearchParams(props.params.pageQuery);
  var showNav = getURLQuery.get('nav') === 'false' ? false : (_props$route$fields$N = props.route.fields.NavSetting) === null || _props$route$fields$N === void 0 ? void 0 : _props$route$fields$N.fields.ShowHeader.value;
  var mainContentId = 'maincontent';
  var SkipToContent = () => {
    return /*#__PURE__*/_react.default.createElement("div", {
      id: "skiptocontent"
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: "#".concat(mainContentId),
      className: "btn btn-inline"
    }, "Skip to main content"));
  };
  var Breadcrumb = () => {
    return /*#__PURE__*/_react.default.createElement(_sitecoreJssReact.Placeholder, {
      name: "breadcrumb-content",
      rendering: props.route,
      params: props.componentProps,
      alignCenter: true
    });
  };
  var checkDateRange = props => {
    startDate = new Date(props.startDate.jss.value);
    expireDate = new Date(props.expireDate.jss.value);
    return (0, _dateFns.isFuture)(startDate) || (0, _dateFns.isPast)(expireDate);
  };
  var getAlerts = props => {
    if (props && props.length > 0) {
      var _props$0$fields;
      var data = (_props$0$fields = props[0].fields) === null || _props$0$fields === void 0 ? void 0 : _props$0$fields.data;
      if (data) {
        var _data$globallevel, _data$pagelevel;
        var globalAlert, pageAlert;
        if (parseInt((_data$globallevel = data.globallevel) === null || _data$globallevel === void 0 || (_data$globallevel = _data$globallevel.results) === null || _data$globallevel === void 0 ? void 0 : _data$globallevel.totalCount) > 0) {
          globalAlert = data.globallevel.results.items;
          (0, _lodash.remove)(globalAlert, function (i) {
            return (0, _lodash.isNil)(i.item) || !i.item.appList.values.some(element => {
              return element.name === appName;
            });
          });
          (0, _lodash.remove)(globalAlert, function (i) {
            return checkDateRange(i.item);
          });
        }
        if (parseInt((_data$pagelevel = data.pagelevel) === null || _data$pagelevel === void 0 || (_data$pagelevel = _data$pagelevel.results) === null || _data$pagelevel === void 0 ? void 0 : _data$pagelevel.totalCount) > 0) {
          pageAlert = data.pagelevel.results.items;
          (0, _lodash.remove)(pageAlert, function (i) {
            return checkDateRange(i.item);
          });
        }
        alertData = (0, _lodash.concat)((0, _lodash.sortBy)(globalAlert, [function (o) {
          return o.item.name;
        }]), (0, _lodash.sortBy)(pageAlert, [function (o) {
          return o.item.name;
        }]));
      }
    }
  };
  getAlerts((0, _lodash.get)(props.route, 'placeholders.alert-content'));
  if (alertData && alertData.length !== 0) {
    //load header nav outside alert. Updates required once BP fixes alert to make it sticky. 
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(SkipToContent, null), /*#__PURE__*/_react.default.createElement(_AlertNotification.default, {
      data: alertData,
      params: props.params,
      showNav: showNav,
      navProps: props.headTagsProps,
      selectedSiteNav: selectedSiteNav
    }), showNav && /*#__PURE__*/_react.default.createElement(_HeaderNav.default, {
      params: props.params,
      headTagsProps: props.headTagsProps,
      selectedSiteNav: selectedSiteNav
    }), props.route.fields.ShowBreadcrumb.value && /*#__PURE__*/_react.default.createElement(Breadcrumb, null), /*#__PURE__*/_react.default.createElement("div", {
      id: mainContentId,
      className: "scroll-top-nav-alert"
    }));
  } else if (showNav) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(SkipToContent, null), /*#__PURE__*/_react.default.createElement(_HeaderNav.default, {
      params: props.params,
      headTagsProps: props.headTagsProps,
      selectedSiteNav: selectedSiteNav
    }), props.route.fields.ShowBreadcrumb.value && /*#__PURE__*/_react.default.createElement(Breadcrumb, null), /*#__PURE__*/_react.default.createElement("div", {
      id: mainContentId,
      className: "scroll-top-nav"
    }));
  } else return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(SkipToContent, null), /*#__PURE__*/_react.default.createElement("div", {
    id: mainContentId,
    className: "scroll-top-nav"
  }));
};
var _default = exports.default = Header;